import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import Switch from '@mui/material/Switch';
import img from '../../../assets/images/user.png'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import { AuthContext } from '../../../context/AuthContext'


const Single = ({user}) => {

  const {contactId} = useParams()
  
  const today = new Date().toDateString()
  
  const [ contactData, setContactData ] = useState("")

 
  const [ openModal, setOpenModal ] = useState(false)

  const closeModal = () => setOpenModal(false)

  const [openStatus, setOpenStatus] = useState(false)

  const { currentUser } = useContext(AuthContext)
        
  const userIds = currentUser.uid;


  useEffect(() => {

    const docRef = doc(db, "contact", contactId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {

      if (docSnap.exists()) {

        setContactData({ id: docSnap.id, ...docSnap.data() });

      } else {
        
        setContactData(null);

      }

    }, (error) => {

      console.error("Error listening to document:", error);

    });

    return () => unsubscribe();

  }, [contactId]);

  const options = {  maximumFractionDigits: 2 }


  const Modal = ({open, close, photo}) => {
     
    if(!open) return null
    return(
     <div style={{
      backgroundColor: 'black',
      widows:'100%',
      height:'100%',
     }}>
       <div style={{

        maxWidth: 600,
        backgroundColor: 'white',
      }}>
       
         <div className="modalRight">
           <p className="closeBtn" onClick={close}>X</p>
           <div></div>

 
         </div>
       </div>
     </div>
    )
}



  return (
    <div className='single'>

      <Modal open={openModal} close={closeModal} />

      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
          <div className='topContainer'>
            <div className='topLeft'><h1>Contact Information</h1></div>
            
            <div className='topRight'>
            <Breadcrumbs aria-label="breadcrumb">
              <a underline="hover" color="inherit" href="/">
                Home
              </a>
              <a
                underline="hover"
                color="inherit"
                href="/contacts"
              >
                Contact List
              </a>
              <Typography color="green">Single Contact</Typography>
            </Breadcrumbs>
            </div>
          </div>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
        
            </div>
            <div className='item'>
              
                <div className="details">
               
                  <div className='detailItem'>
                    <span className='itemKey'>Contact Subject:</span>
                    <span className='itemValue'>{contactData.subject}</span>
                  </div>
                  <div className='detailItem' style={{width:420}}>
                    <span className='itemKey'>Message:</span>
                    <span className='itemValue'>{contactData.message}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Phone Numberl:</span>
                    <span className='itemValue'>{contactData.telephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{contactData.status}</span>
                  </div>
                </div>


                <div className="details" style={{width:320}}>
                  <div className='detailItem'>
                    <span className='itemKey'>Telephone:</span>
                    <span className='itemValue'>{contactData.telephone}</span>
                  </div>
                
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{contactData.email}</span>
                  </div>
                

                </div>

            </div>
          </div>
          
        </div>
      

      </div>
    </div>
  )
}

export default Single